// Single source of truth for the BLS "Gitcha Pro" add-on plan content.
// Consumed by PremiumPlanModal, PlanReviewModal, and ProfileAgentUser so the
// copy, feature list, prices, and Stripe plan ids can't drift across surfaces.

export const BLS_PRO_DISPLAY_NAME = "Gitcha Pro";
export const BLS_LITE_DISPLAY_NAME = "Gitcha Lite";

export const blsProDescription = (mlsShortName = "MLS") =>
  `Everything in your ${mlsShortName} seat, plus the tools to turn every Want-Listing into a marketing asset - and become the buyer agent clients pick first.`;

export const BLS_PRO_FEATURES = [
  {
    label: "Detailed Buyer Agent Profile",
    benefit:
      "Profile photo, bio, testimonials, website, social links, and your buyer-onboarding form - all in one place. Consumers find you, see your active Want-Listings, and reach out.",
  },
  {
    label: "Branded Buyer Onboarding Form",
    benefit:
      "A static link you can bookmark, send to any client, or embed on your website. Clients feel heard - and the form gives you a head start on your next Want-Listing so you're not entering the same data twice.",
  },
  {
    label: "Want-Listing Videos",
    benefit:
      "Attach a video to any Want-Listing - pitch what your buyer's looking for, or pitch yourself and the services you offer.",
  },
  {
    label: "Enhanced Social Share Cards",
    benefit:
      "Auto-generated graphics for every Want-Listing - drop straight into Instagram, LinkedIn, Facebook.",
  },
  {
    label: "Pro Badge across Gitcha",
    benefit:
      "First impression matters. The Pro badge tells the Gitcha network you're serious about buyer-side.",
  },
];

export const BLS_PRO_COMING_SOON = {
  label: "Open House Lead Capture",
  benefit:
    "Every open house becomes a buyer pipeline with a branded sign-in flow.",
};

// Flat label list for compact summaries (e.g. PlanReviewModal's review card).
export const blsProFeatureLabels = [
  ...BLS_PRO_FEATURES.map((f) => f.label),
  `${BLS_PRO_COMING_SOON.label} (Coming Soon)`,
];

// Prices + Stripe plan ids in one place. planId 3 = annual, 2 = monthly
// (matches handleUpgrade's existing period argument).
export const BLS_PRO_PRICING = {
  annual: { perMo: 12, perYr: 144, planId: 3 },
  monthly: { perMo: 10, planId: 2 },
};
